
















































































import { getAutocompleteFilter } from "@/lib/utility/filter";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IAddress } from "@/models/address.entity";
import { Company, ICompany } from "@/models/company.entity";
import { IInvoiceParty, InvoiceParty } from "@/models/invoice-party.entity";
import { IPerson, Person } from "@/models/person.entity";
import { IReference } from "@/models/reference.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { RefsCompanyModule, RefsPersonModule } from "@/store/modules/refs.store";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import RefsSelect from "../utility/RefsSelect.vue";
import RefsSelectForm from "../utility/RefsSelectForm.vue";

@Component({
  components: {
    RefsSelectForm,
    RefsSelect
  },
  filters: {}
})
export default class InvoiceCreateDialogPartyForm extends mixins(RulesMixin, PermissionMixin) {
  readonly getAutocompleteFilter = getAutocompleteFilter;

  @Prop()
  value!: IInvoiceParty;

  @Prop()
  partnerId!: string;

  company: ICompany | null = null;
  person: IPerson | null = null;

  get addresses() {
    return (this.company?.addresses ?? this.person?.addresses ?? []) as IAddress[];
  }

  get emails() {
    if (this.person?.emails?.length) {
      return this.person?.emails.map(e => e.email);
    }
    if (this.company?.contact?.email) {
      return [this.company?.contact?.email];
    }
    return [];
  }

  get phones() {
    if (this.person?.phones?.length) {
      return this.person?.phones.map(e => e.phone);
    }
    if (this.company?.contact?.phone) {
      return [this.company?.contact?.phone];
    }
    return [];
  }

  private async buildInvoicePartyFromPersonRef(ref: IReference) {
    const invoiceParty = new InvoiceParty();
    if (ref.refType !== ResourceEnum.PERSON) {
      return;
    }
    let person: IPerson | null = RefsPersonModule.maps.id.get(ref.refId)[0];
    if (!person) {
      person = await new Person({ id: ref.refId, partnerId: this.partnerId }).fetch().catch(e => {
        this.$log.error(e);
        return null;
      });
    }
    if (!person) {
      return { invoiceParty: null, person: null };
    }

    invoiceParty.name = "";
    if (person.firstName) {
      invoiceParty.name = person.firstName;
    }
    if (person.lastName) {
      if (invoiceParty.name) {
        invoiceParty.name += " ";
      }
      invoiceParty.name += person.lastName;
    }
    if (person.emails?.length) {
      invoiceParty.email = person.emails[0].email;
    } else {
      invoiceParty.email = undefined;
    }
    if (person.phones?.length) {
      invoiceParty.phone = person.phones[0].phone;
    } else {
      invoiceParty.phone = undefined;
    }
    if (person.addresses?.length) {
      invoiceParty.address = person.addresses[0] as IAddress;
    }

    return { invoiceParty, person };
  }

  private async buildInvoicePartyFromCompanyRef(ref: IReference) {
    const invoiceParty = new InvoiceParty();
    if (ref.refType !== ResourceEnum.COMPANY) {
      return;
    }

    let company: ICompany | null = RefsCompanyModule.maps.id.get(ref.refId)[0];
    if (!company) {
      company = await new Company({ id: ref.refId, partnerId: this.partnerId }).fetch().catch(e => {
        this.$log.error(e);
        return null;
      });
    }
    if (!company) {
      return { invoiceParty: null, company: null };
    }

    invoiceParty.name = "";
    if (company.firstName) {
      invoiceParty.name = company.firstName;
    }
    if (company.lastName) {
      if (invoiceParty.name) {
        invoiceParty.name += " ";
      }
      invoiceParty.name += company.lastName;
    }
    if (company.company) {
      if (invoiceParty.name) {
        invoiceParty.name += " ";
      }
      invoiceParty.name += company.company;
    }

    invoiceParty.email = company.contact?.email;
    invoiceParty.phone = company.contact?.phone;

    if (company.addresses?.length) {
      invoiceParty.address = company.addresses[0] as IAddress;
    }

    invoiceParty.taxnumber = company.taxnumber;

    return { invoiceParty, company };
  }

  async buildInvoicePartyFromCompanyOrPersonRef(refs: IReference[]) {
    const ref = refs[refs.length - 1];
    if (!ref) {
      return {
        invoiceParty: null,
        person: null,
        company: null
      };
    }

    let person: IPerson | null = null;
    let company: ICompany | null = null;
    let invoiceParty: IInvoiceParty | null = null;

    if (ref?.refType === ResourceEnum.PERSON) {
      const res = await this.buildInvoicePartyFromPersonRef(ref);
      invoiceParty = res?.invoiceParty ?? null;
      person = res?.person ?? null;
    } else if (ref?.refType === ResourceEnum.COMPANY) {
      const res = await this.buildInvoicePartyFromCompanyRef(ref);
      invoiceParty = res?.invoiceParty ?? null;
      company = res?.company ?? null;
    }

    return {
      invoiceParty,
      person,
      company
    };
  }

  async setInvoicePartyFromCompanyOrPersonRef(refs: IReference[]) {
    const { person, company, invoiceParty } = await this.buildInvoicePartyFromCompanyOrPersonRef(refs);

    this.person = person;
    this.company = company;
    this.value.map(invoiceParty ?? new InvoiceParty());
  }

  buildInvoicePartyFromPartner() {
    const partner = PartnerModule.partner;
    const invoiceParty = new InvoiceParty();
    invoiceParty.name = partner.companyName;
    if (partner.contact?.phone) {
      invoiceParty.phone = partner.contact?.phone;
    }
    if (partner.contact?.email) {
      invoiceParty.email = partner.contact?.email;
    }
    invoiceParty.phone;
    if (partner.address) {
      invoiceParty.address = partner.address as IAddress;
    }

    return invoiceParty;
  }

  setInvoicePartyFromPartner() {
    const invoiceParty = this.buildInvoicePartyFromPartner();
    this.value.map(invoiceParty ?? new InvoiceParty());
  }
}
